<template>
  <div class="pagination-wrap">
    <div class="left-wrap">共{{ total }}条记录</div>
    <div class="right-wrap">
      <!-- <a-pagination
        size="small"
        :total="totals"
        @change="pageChange"
        show-size-changer
        show-quick-jumper
        :item-render="itemRender"
      /> -->
      <a-pagination
        v-model="currenPage"
        :page-size-options="pageSizeOptions"
        :total="total"
        show-size-changer
        show-quick-jumper
        :page-size="currentSize"
        @showSizeChange="onShowSizeChange"
        @change="pageNumChange"
      >
      </a-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: Number,
    pageSize: Number,
    pageNum: Number
  },
  data () {
    return {
      pageSizeOptions: ['5', '10', '15', '30', '50'],
      currenPage: 1,
      currentSize: 10
    }
  },
  watch: {
    pageNum (val) {
      this.currenPage = val
    },
    pageSize (val) {
      this.currentSize = val
    }
  },
  mounted () {
     this.currentSize = this.pageSize
  },
  methods: {
    pageNumChange (val) {
      this.$emit('change', { current: val })
    },
    onShowSizeChange (current, pageSize) {
      this.currentSize = pageSize
      this.$emit('change', { current, pageSize })
    }
  }
}
</script>

<style>
</style>
